import { cn } from "../ui/cn";

type PlayTriangleIconProps = {
  size?: number;
  color?: string;
  variant?: "play" | "chevron";
  className?: string;
  style?: React.CSSProperties;
};

export default function PlayTriangleIcon({
  size = 10,
  color = "currentColor",
  variant = "play",
  className,
  style,
}: PlayTriangleIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("block", className)}
      style={style}
      aria-hidden="true"
    >
      {variant === "play" ? (
        <path d="M2 1.8L8.2 5L2 8.2V1.8Z" fill={color} />
      ) : (
        <path
          d="M2.2 1.8L6.6 5L2.2 8.2"
          stroke={color}
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
    </svg>
  );
}
